import React from "react";
import { useTranslation } from "react-i18next";

import { OnboardingSteps } from "../../utils/constants";
import FindFriendsPage from "../onboarding/FindFriendsPage/FindFriendsPage";
import GetAppPage from "../onboarding/GetAppPage/GetAppPage";
import TurnOnNotificationsPage from "../onboarding/TurnOnNotificationsPage/TurnOnNotificationsPage";
import LoginSuccessfulPage from "../onboarding/LoginSuccessfulPage/LoginSuccessfulPage";
import useOnboardingSteps from "../../hooks/useOnboardingSteps";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../utils/renderHeaders";
import JoinCommunityPage from "../onboarding/JoinCommunityPage/JoinCommunityPage";
import InstallTestflightPage from "../onboarding/InstallTestflightPage/InstallTestflightPage";

function LoginWelcomeFlowPage() {
  const { currentStep } = useOnboardingSteps();
  const { t } = useTranslation();

  let contentEl: JSX.Element;

  switch (currentStep) {
    case OnboardingSteps.LOG_IN_SUCCESSFUL:
      contentEl = <LoginSuccessfulPage />;
      break;
    case OnboardingSteps.FIND_FRIENDS:
      contentEl = <FindFriendsPage />;
      break;
    case OnboardingSteps.GET_APP:
      contentEl = <GetAppPage />;
      break;
    case OnboardingSteps.JOIN_COMMUNITY:
      contentEl = <JoinCommunityPage />;
      break;
    case OnboardingSteps.TURN_ON_NOTIFICATIONS:
      contentEl = <TurnOnNotificationsPage />;
      break;
    case OnboardingSteps.INSTALL_TEST_FLIGHT:
      contentEl = <InstallTestflightPage />;
      break;
    default:
      contentEl = <LoginSuccessfulPage />;
  }

  return (
    <>
      {renderHeaders({
        title: t("metadata:sigma_onboarding_title"),
        description: t("metadata:sigma_onboarding_description"),
        ogTitle: extractOgTitleFromMainTitle(
          t("metadata:sigma_onboarding_title")
        ),
      })}
      {contentEl}
    </>
  );
}

export default LoginWelcomeFlowPage;
